<template>
  <div class="rt-view-wrapper"><slot /></div>
</template>

<script>
export default {
  name: 'RtView'
};
</script>

<style lang="less">
.rt-view-wrapper {
  .rt-form-item-wrapper {
    margin-bottom: 0;
    margin-top: 20px;
    &.is-error .el-input__inner {
      border-color: #f56c6c !important;
    }
    .el-form-item__label {
      font-size: 14px;
      color: #6388c2;
      line-height: 14px;
      height: 14px;
      margin-bottom: 4px;
      padding: 0;
      position: relative;
    }
    .el-input__inner {
      border: none;
      border-bottom: 1px solid #e8ecfc;
      padding: 0;
      color: #143e81;
      font-size: 14px;
      &::placeholder {
        color: #dbe0f3;
      }
    }
    .el-input__suffix,
    .el-input__prefix {
      color: #dbe0f3;
      .rt-icon {
        //   padding: 8px 0;
      }
    }
    .el-input__suffix {
      display: flex;
      align-items: center;
      right: 0;
    }
    .el-input__prefix {
      display: flex;
      align-items: center;
      left: 0;
    }

    &.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
      content: '*';
      color: #f5222d;
      position: absolute;
      right: -16px;
      top: 2px;
    }

    .el-input.is-disabled .el-input__inner {
      background: #fff;
      color: #4f5e7b;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtView.vue?7ec2b5ed